import { render, staticRenderFns } from "./PaymentPendingBanner.vue?vue&type=template&id=7ad3fd51&"
import script from "./PaymentPendingBanner.vue?vue&type=script&lang=js&"
export * from "./PaymentPendingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports